export var Theme;
(function (Theme) {
    Theme[Theme["Dark"] = 0] = "Dark";
    Theme[Theme["Light"] = 1] = "Light";
    Theme[Theme["HCBlack"] = 2] = "HCBlack";
    Theme[Theme["HCWhite"] = 3] = "HCWhite";
    Theme[Theme["HCAquatic"] = 4] = "HCAquatic";
    Theme[Theme["HCDesert"] = 5] = "HCDesert";
})(Theme || (Theme = {}));
//# sourceMappingURL=Theme.js.map